import Link from 'next/link';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { BlockContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TProduct } from '~/src/features/aboutV2/components/Products/data';

import * as ST from './styled';

type TProps = TProduct & { contentReverse?: boolean };

const ContentBlock = ({ title, text, img, imgWebp, imgAlt, btnLink, btnText, contentReverse = false }: TProps) => {
    return (
        <BlockContainer indent={{ $mobile: [8], $desktop: [12] }} rounder={{ $radius: 32 }} bgColor={COLORS.BgMain}>
            <ST.ImageWrapper contentReverse={contentReverse}>
                <WebpImage urlWebp={imgWebp}>
                    <img src={img} alt={imgAlt} />
                </WebpImage>
            </ST.ImageWrapper>
            <IndentContainer $mobile={[24, 16, 16]} $desktop={[contentReverse ? 12 : 32, 20, 20]}>
                <ListContainer $mobile={24} $desktop={32}>
                    <TextWrapper $lastIndent={false}>
                        <H3 $withIndent={false}>{title}</H3>
                        <Paragraph4 $withIndent dangerouslySetInnerHTML={{ __html: text }} />
                    </TextWrapper>
                    <Link href={btnLink} passHref>
                        <ButtonGroup>
                            <Button bType='secondary'>{btnText}</Button>
                        </ButtonGroup>
                    </Link>
                </ListContainer>
            </IndentContainer>
        </BlockContainer >
    );
};

export default ContentBlock;
